import { MaterialService } from './material.service';
import { FormationOptions } from './../model/formationOptions.model';
import { Formation } from './../model/formation.model';
import { FormationList } from './../model/formationList.model';
import { FormationHoursInfo } from './../model/formationHoursInfo.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';

import { OccurrenceService } from './occurrence.service';
import { EventService } from './event.service';
import { Occurrence } from '../model/occurrence.model';
import { Router } from '@angular/router';
//
import { Observable, forkJoin, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ExportCdcCertificationLog } from '../model/exportCdcCertificationLog.model';
import { ExportCdcCertificationValidity } from '../model/exportCdcCertificationValidity.model';
import { ExportCdcCertificationList } from '../model/exportCdcCertificationsList.model';
import moment from 'moment-timezone';

@Injectable()
export class FormationService extends KiwixiService {

  apiFormations = environment.server + 'formations/';
  public currentFormationSubject: BehaviorSubject<Formation> = new BehaviorSubject<Formation>(null);
  public nextOccurrence: BehaviorSubject<Occurrence> = new BehaviorSubject<Occurrence>(null);
  public listeFormations: BehaviorSubject<Formation[]> = new BehaviorSubject<Formation[]>(null);

  public getExerciceDurataionPerClass(): number {
    return 20;
  }

  constructor(private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private eventService: EventService, private occurrenceService: OccurrenceService,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  public getMaxReportPerFormation(formation: Formation) {
    return 999;
    // if (formation.hours_total >= 60) {
    //   return 16;
    // } else if (formation.hours_total >= 40 && formation.hours_total < 60) {
    //   return 12;
    // } else if (formation.hours_total >= 20 && formation.hours_total < 40) {
    //   return 8;
    // } else {
    //   return 4;
    // }
  }

  public getFormations(_filterParams): Promise<Object[]> {
    let params = new HttpParams();
    if (_filterParams['ordering']) {
      const f = _filterParams['ordering'];
      params = params.set(f.key, f.value);
    }
    if (_filterParams['filtering']) {
      for (const filterParam of Object.keys(_filterParams['filtering'])) {
        params = params.set(filterParam, _filterParams['filtering'][filterParam]);
      }
    }
    if (_filterParams['page']) {
      params = params.set('page', _filterParams['page']);
    }
    const headers = this.createHttpClientAuthorizationHeader();

    return this._http.get(this.apiFormations, { headers: headers, params: params })
      .toPromise()
      .then((res: any) => res)
      .catch(this.handleError);
  }

  getFormation(id): Promise<Formation> {
    const url = this.apiFormations + id;
    return this.getFormationWithUrl(url);
  }

  getFormationWithUrl(url): Promise<Formation> {
    const headers = this.createHttpClientAuthorizationHeader();
    if (!url.endsWith('/')) {
      url = url + '/';
    }
    this.checkCredential();
    return this._http.get(url, { headers: headers })
      .toPromise()
      .then((res: any) => {
        const body = res;
        return body;
      })
      .catch(error => {
        console.error('Formation error', error);
        this.logout();
      })
  }

  getFormationsFromStudent(urlStudent): Observable<Formation[]> {
    const header = this.createHttpClientAuthorizationHeader();
    const student_id = urlStudent.split('/')[urlStudent.split('/').length - 2]
    return this._http.get<Formation[]>(this.apiFormations, {
      headers: header,
      params: new HttpParams().set('student_id', student_id),
    }).pipe(
      tap(h => {
        const outcome = h ? `fetched` : `did not find`;
      }),
      map(result => <Formation[]>result['results']),
      catchError(this.handleErrorObservable<Formation[]>(`getFormationsFromStudent id_student=${urlStudent}`))
    )
  }

  /**
   * Récupère les formations d'un étudiant par son ID 
   * @param studentId - ID de l'étudiant
   * @returns Observable<FormationList>
   */
  getFormationsByStudentId(studentId: number): Observable<FormationList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(this.apiFormations, {
      headers: header,
      params: new HttpParams().set('student__id', studentId.toString()),
    }).pipe(
      catchError(this.handleErrorObservable<FormationList>(`getFormationsByStudentId id=${studentId}`))
    )
  }

  patchFormation(formationUrl, param): Promise<Formation> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch(formationUrl, JSON.stringify(param), { headers: headers })
      .toPromise()
      .then((res: any) => {
        const body = res;
        return body;
      })
      .catch(error => {
        this.materialService.openSnackBar(`La sauvegarde de la formation a échouée`, 'red')
        console.error('error patch Event service', error);
      })
  }

  patchObservableFormation(formationUrl, params) {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch<Formation>(formationUrl, params, { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<Formation>(`Mise à jour d'une formation`)),
      );
  }

  postFormation(formation): Promise<Formation> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.post(this.apiFormations, formation, {
      headers: headers
    })
      .toPromise()
      .then((res: any) => {
        const body = res;
        return body;
      })
      .catch(error => {
        let errors_list = [];
        for (let e in error.error) {
          errors_list.push(error.error[e])
        }
        this.materialService.openSnackBar('La sauvegarde de la formation a échouée : ' + errors_list.join(' '), 'red')
        console.error('error postFormation service', error);
      })
  }

  getStatus() {
    return [
      {
        label: 'En cours',
        code: 'active',
        valid: true
      },
      {
        label: 'En attente',
        code: 'pending',
        valid: true
      },
      {
        label: 'Terminée',
        code: 'done',
        valid: true
      },
      {
        label: 'Annulée',
        code: 'cancelled',
        valid: true
      },
      {
        label: 'Suspendue',
        code: 'suspended',
        valid: true
      }
    ];
  }

  getExportStatus() {
    return [
      {
        label: 'A exporter',
        code: 'to_export',
      },
      {
        label: 'En attente',
        code: 'pending',
      },
      {
        label: 'Exporté',
        code: 'exported',
      },
    ];
  }

  getModeFinancement() {
    return [
      {
        label: 'FNE',
        code: 'fne',
        sfName: 'FNE'
      },
      {
        label: 'CPF',
        code: 'cpf',
        sfName: 'Compte Personnel de Formation'
      },
      {
        label: 'Autres',
        code: 'autres',
        sfName: 'Autres'
      },
      {
        label: 'Entreprise',
        code: 'entreprise',
        sfName: 'Entreprise'
      },
      {
        label: 'Plan de développement et de compétences - OPCO',
        code: 'opco',
        sfName: 'OPCO'
      },
      {
        label: "Service public (on forme les gens de l'Etat)",
        code: 'service_public',
        sfName: 'Service public'
      },
      {
        label: 'Pôle Emploi',
        code: 'pole_emploi',
        sfName: 'Pôle Emploi'
      },
      {
        label: 'Sous-traitance',
        code: 'sous_traitance',
        sfName: 'Sous-traitance'
      },
      {
        label: 'Financement personnel',
        code: 'financement_personnel',
        sfName: 'Financement personnel'
      },
    ];
  }

  getBookingMode() {
    return [
      {
        label: 'Recurrent',
        code: 'rec',
      },
      {
        label: 'Ponctuel',
        code: 'ponctual',
      },
      {
        label: 'Les deux',
        code: 'all',
      },
    ];
  }

  getOccurrences(studentId, formationId, count, salt = false): Promise<Occurrence[]> {
    let filterParams = [
      {
        key: 'student',
        value: studentId
      },
      {
        key: 'formation',
        value: formationId
      },
      {
        key: 'ordering',
        value: 'by_hour'
      },
      {
        key: 'page',
        value: count
      }
    ]
    if (salt) {
      filterParams.push({ key: 'salt', value: Math.random().toString() })
    }
    return this.occurrenceService.getOccurrences(filterParams);
  }

  saveEvents(formation): Observable<any> {
    const obx = [];
    for (const event of formation.events) {
      if (event.start && event.end) {
        obx.push(this.eventService.saveEvent(event));
      }
    }
    return forkJoin(obx).pipe(
      map(responses => {
        formation.events = responses;
      })
    )
  }

  saveEvents2(formation): Observable<any> {
    const obx = [];
    for (const event of formation.events) {
      if (event.start && event.end) {
        obx.push(this.eventService.saveEvent(event));
      }
    }
    return forkJoin(obx)
    // .map(responses => responses[0])
  }

  saveFormation(formation): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch(formation.url, JSON.stringify(formation), { headers: headers }).pipe(
      map(
        res => res
      ),
      catchError(this.handleErrorObservable('La sauvegarde de formation a échouée', formation))
    )
  }

  searchTrainings(_teacher, term, _countPages, _status): Observable<Formation[]> {
    const params = new HttpParams()
      .set('teachers', _teacher.id)
      .set('status', _status)
      .set('student_name', term)
      .set('page', _countPages.toString())
      .set('ordering', 'student__user__last_name')
    return this.getObservableFormations(params)
  }

  getCountTrainings(_teacher, _status): Observable<Number> {
    const params = new HttpParams()
      .set('teachers', _teacher.id)
      .set('status', _status)
    return this.getObservableCountFormations(params)
  }

  getObservableFormations(params: HttpParams): Observable<Formation[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Formation[]>(this.apiFormations, {
      headers: header,
      params: params
    })
      .pipe(
        catchError(this.handleErrorObservable<Formation[]>(`getFormations`))
      );
  }

  getObservableFormation(idFormation): Observable<Formation> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Formation>(this.apiFormations + idFormation + '/', {
      headers: header
    })
      .pipe(
        map(_trainings => _trainings),
        catchError(this.handleErrorObservable<Formation>(`getFormations`))
      );
  }

  getFormationHoursInfo(idFormation): Observable<FormationHoursInfo> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Formation>(this.apiFormations + idFormation + '/hours_info/', {
      headers: header
    })
      .pipe(
        catchError(this.handleErrorObservable<FormationHoursInfo>(`getFormationsHoursInfo`))
      );
  }

  getObservableCountFormations(params: HttpParams): Observable<Number> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Number>(this.apiFormations, {
      headers: header,
      params: params
    })
      .pipe(
        map(_trainings => _trainings['count']),
        catchError(this.handleErrorObservable<Number>(`getObservableCountFormations`))
      );
  }

  /**
   * Listing des formations au format allégé : l'élève, les professeurs et la langue
   * sont embarqués dans la réponse, ce qui évite un appel par ligne côté listing.
   */
  getObservableFormationsListing(params: HttpParams): Observable<FormationList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<FormationList>(this.apiFormations, {
      headers: header,
      params: params.set('light', 'true')
    })
      .pipe(
        catchError(this.handleErrorObservable<FormationList>(`getObservableFormationsListing`))
      );
  }

  getObservableDataFormations(params: HttpParams): Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(this.apiFormations, {
      headers: header,
      params: params
    })
      .pipe(
        catchError(this.handleErrorObservable<any>(`getObservableDataFormations`))
      );
  }

  getObservableFormationById(id): Observable<Formation> {
    const url = this.apiFormations + id + '/' + '?salt=' + Math.random().toString();
    return this.getObservableFormationByUrl(url);
  }

  getObservableFormationByUrl(_url): Observable<Formation> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Formation>(_url, {
      headers: header
    })
      .pipe(
        catchError(this.handleErrorObservable<Formation>(` `))
      );
  }

  getFormationsByUrl(_url): Observable<FormationList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<FormationList>(_url, {
      headers: header
    })
      .pipe(
        catchError(this.handleErrorObservable<FormationList>(`getFormationsListByUrl`))
      );
  }


  getMultipleFormations(formationsUrl) {
    const obx = [];
    for (const url of formationsUrl) {
      obx.push(this.getObservableFormationByUrl(url))
    }
    return forkJoin<Formation[]>(obx)
  }

  cleanCache(idFormation): Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(this.apiFormations + 'cache/update/' + idFormation + '/', {
      headers: header
    })
    // .pipe(
    //   catchError(this.handleErrorObservable<any>(`cleanCache`))
    // );
  }


  getDefaultFormation(): Formation {
    if (this.listeFormations.value) {
      const formations = this.listeFormations.value;
      const _formations_active = formations.filter(_formation => _formation['status'] === 'active');
      if (_formations_active.length > 0) {
        return _formations_active[0];
      } else {
        return formations[0];
      }
    }

  }

  checkFormationSessionForceDurationExist(formation) {
    const findForceDuration = formation.options.filter(option => option.option_type === 'force_duration').length;
    if (findForceDuration > 0) {
      return true
    }
    return false
  }

  getFormationSessionForceDuration(formation) {
    const findForceDuration: FormationOptions[] = formation.options.filter(option => option.option_type === 'force_duration');
    if (findForceDuration.length > 0) {
      return findForceDuration[0];
    } else {
      return null;
    }
  }

  getExports(params: HttpParams): Observable<ExportCdcCertificationList> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<ExportCdcCertificationList>(environment.server + 'export_cdc_certifications/', { headers: headers, params: params });
  }


  getExportById(exportId): Observable<ExportCdcCertificationLog> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<ExportCdcCertificationLog>(environment.server + 'export_cdc_certifications/' + exportId + '/', { headers: headers });
  }

  checkValidityFormations(selectedFormations): Observable<ExportCdcCertificationValidity[]> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.post<ExportCdcCertificationValidity[]>(environment.server + 'export_cdc_certifications/export/check_formations_validity/', selectedFormations, { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<ExportCdcCertificationValidity[]>(`Verification de la validité des formations`)),
      );
  }

  postExport(params) {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.post<ExportCdcCertificationLog>(environment.server + 'export_cdc_certifications/export/create/', params,
      { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<ExportCdcCertificationLog>(`Création d'une réponse type choice`)),
      );
  }

  patchExport(exportId, params) {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.patch<ExportCdcCertificationLog>(environment.server + 'export_cdc_certifications/' + exportId + '/', params,
      { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<ExportCdcCertificationLog>(`Création d'une réponse type choice`)),
      );
  }

  downloadExport(_url, _filename, _contentType) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(_url, { headers: header, responseType: 'arraybuffer' }).pipe(
      map((file) => {
        this.downloadFile(_filename, file, _contentType);
      })
    )
  }

  postCdcLogFile(exportCdcCertificationLog: ExportCdcCertificationLog, file: File) {
    const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
    headers.delete('Content-Type');
    const _formData: FormData = new FormData();
    _formData.append('enctype', 'multipart/form-data');
    _formData.append('log_file', file);
    _formData.append('name', file.name);

    return this._http.post<ExportCdcCertificationLog>(environment.server + 'export_cdc_certifications/export/uploadlog/' + exportCdcCertificationLog.id + '/', _formData, { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<ExportCdcCertificationLog>(`Upload log export`)),
      );
  }

  downloadCertificateAttendance(id, _filename) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiFormations + id + '/generate_attendance/', { headers: header, responseType: 'arraybuffer' }).pipe(
      map((file) => {
        this.downloadFile(_filename, file, 'application/pdf');
      })
    )
  }

  downloadEndOfTrainingAttestation(id, _filename) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiFormations + id + '/generate_end_of_training_attestation/', { headers: header, responseType: 'arraybuffer' }).pipe(
      map((file) => {
        this.downloadFile(_filename, file, 'application/pdf');
      })
    )
  }

  downloadExportEdof(id, _filename) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiFormations + id + '/extract_edof_data/', { headers: header, responseType: 'arraybuffer' }).pipe(
      map((file) => {
        this.downloadFile(_filename, file, 'application/zip');
      })
    )
  }

  getHistorySessions(id): Observable<any[]> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<any[]>(this.apiFormations + id + '/history_sessions/', { headers: headers });
  }

  getFormationNotifications(formationId: number, pageSize: number = 25): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    const params = new HttpParams().set('page_size', pageSize.toString());
    return this._http.get<any>(this.apiFormations + formationId + '/notifications/', { headers, params }).pipe(
      catchError(this.handleErrorObservable<any>(`getFormationNotifications id=${formationId}`))
    );
  }

  getFormationNotificationsWithUrl(url: string): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(url, { headers }).pipe(
      catchError(this.handleErrorObservable<any>('getFormationNotificationsWithUrl'))
    );
  }

  getFormationNotificationById(formationId: number, notificationId: number): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(
      `${this.apiFormations}${formationId}/notifications/${notificationId}/`,
      { headers }
    ).pipe(
      catchError(this.handleErrorObservable<any>(`getFormationNotificationById id=${notificationId}`))
    );
  }

  downloadHistorySessionsXls(id, _filename) {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiFormations + id + '/history_sessions_xls/', { headers: header, responseType: 'arraybuffer' }).pipe(
      map((file) => {
        this.downloadFile(_filename, file, 'application/vnd.ms-excel');
      })
    )
  }

  downloadFormationLevelAttestationPdf(formation: Formation) {
    const header = this.createHttpClientAuthorizationHeader();

    this._http.get(this.apiFormations + 'level_attestation/generatepdf/' + formation.id + '/', { headers: header, responseType: 'arraybuffer' })
      .subscribe((file: ArrayBuffer) => {
        const _name = '_' + formation.student.user.first_name + '_' + formation.student.user.last_name;
        const filename = 'attestation_niveau_' + _name;
        this.downloadFile(filename, file, 'application/pdf');
      });
  }

  getModePlanification(formation: Formation) {
    return formation.options.filter(o => o.option_type === 'set_plan_rec_algo').length > 0 ? formation.options.filter(o => o.option_type === 'set_plan_rec_algo')[0].value : 'linear_date_around';
  }

  postProlongation(formationId, params) {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.post<Formation>(this.apiFormations + formationId + '/prolongation/', params, { headers: headers })
  }


  importFormation(params) {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.post<any>(environment.server + 'import_formation/', params, { headers: headers })
  }

  uploadFormationCsv(file: File) {
    const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
    headers.delete('Content-Type');
    const formData = new FormData();
    formData.append('enctype', 'multipart/form-data');
    formData.append('csv_file', file);
    formData.append('name', file.name);

    return this._http.post<any>(environment.server + 'import_formation/upload_csv/', formData, { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<any>('Upload import formations CSV')),
      );
  }

  getImports(params: HttpParams): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(environment.server + 'imports_formation/', { headers: headers, params: params });
  }

  getImportById(id: number): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<any>(environment.server + 'imports_formation/' + id + '/', { headers: headers });
  }

  getImportErrorLogs(importId: number, params?: HttpParams): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    let queryParams = params || new HttpParams();
    queryParams = queryParams.append('import_formation', importId.toString());
    return this._http.get<any>(environment.server + 'imports_formation_error_logs/', { headers: headers, params: queryParams });
  }

  checkIdentidyValidity(formation: Formation) {
    const dateProfileFeature = moment({ y: 2021, M: 3, d: 19, h: 0, m: 0, s: 0 });
    // si la date de debut de formation est avant la mise en ligne de la fonction, c'est valide
    if ((formation.status === 'active' || formation.status === 'done' || formation.status === 'suspended') && moment(formation.validity_period_from).isBefore(dateProfileFeature)) {
      return true;
    } else { // si après la mise en ligne
      // si pas de profile
      if (!formation.student.user.photo_profile) {
        return false;
      }
      else { // si profile
        // et cela a été validé
        if (formation.student.user.photo_profile.status == 'validated') {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  refreshFormation(formationId) {
    this.getObservableFormationById(formationId).subscribe(_formation => {
      this.currentFormationSubject.next(_formation);
    })
  }


  downloadOldFormationLilatePdf(formation: Formation) {
    const header = this.createHttpClientAuthorizationHeader();

    this._http.get(this.apiFormations + 'generate_lilate_pdf/' + formation.id + '/', { headers: header, responseType: 'arraybuffer' })
      .subscribe((file: ArrayBuffer) => {
        const _name = '_' + formation.student.user.first_name + '_' + formation.student.user.last_name;
        const filename = 'certificat_' + _name;
        this.downloadFile(filename, file, 'application/pdf');
      });
  }

  getFormationExercicesInfo(idFormation): Observable<any> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiFormations + idFormation + '/exercices_info/' + '?salt=' + Math.random().toString(), { headers: headers })
      .pipe(
        catchError(this.handleErrorObservable<any>(`getFormationExercicesInfo`))
      );
  }
}
